import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { dismissAppointmentRescheduleRequest } from '@/api/appointments/appointmentsApi';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';
import { APPOINTMENTS_QUERY_KEY, WORKSPACE_ATTENTION_QUERY_KEY } from '@/constants/queryKeys';

export function useDismissRescheduleRequestMutation(): UseMutationResult<
  Appointment,
  Error,
  string
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: dismissAppointmentRescheduleRequest,
    onSuccess: function invalidate() {
      queryClient.invalidateQueries({ queryKey: APPOINTMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: WORKSPACE_ATTENTION_QUERY_KEY });
    },
  });
}
